import React, { useEffect, useState } from 'react'
import { apiGet, apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import formValidation from 'utils/formValidation'
import OSelect from 'components/reusable/OSelect'

const SubCategoryAdd = ({ allSubCategory, handleCategory }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [categoryList, setCategoryList] = useState([])
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })
  const [addMerchantLoading, setAddMerchantLoading] = useState(false)

  const onSubmit = async data => {
    setAddMerchantLoading(true)
    try {
      const res = await apiPost(apiPath.addPropertyCategory, { ...data })
      if (res?.data?.success === true) {
        allSubCategory()
        handleCategory(false)
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.error('err:', err)
    } finally {
      setAddMerchantLoading(false)
    }
  }

  const allCategory = async payload => {
    try {
      const path = apiPath.listPropertyType
      const result = await apiGet(path, payload)
      if (result?.data?.success) {
        const response = result?.data?.results
        const categoriesList = response?.map(item => {
          return { key: item?.name, value: item?._id, keyAr: item?.nameAr }
        })
        setCategoryList(categoriesList)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allCategory()
  }, [])

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('ADD_PROPERTY_CATEGORY')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleCategory(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl '>×</span>
                </button>
              </div>

              
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OSelect
                      wrapperClassName='relative z-0 mb-6 w-full group'
                      name='propertyTypeId'
                      inputLabel={
                        <>
                          {t('O_PROPERTY_TYPE')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='select'
                      options={categoryList}
                      defaultValue={t('O_SELECT_PROPERTY_TYPE')}
                      register={register(
                        'propertyTypeId',
                        formValidation.propertyTypeId
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='shortName'
                      inputLabel={
                        <>
                          {t('O_SHORT_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register('shortName', formValidation.shortName)}
                      errors={errors}
                      value={watch('shortName')?.toUpperCase()}
                      // onChange={(event) => {
                      //   event.target.value = event.target.value.toUpperCase();
                      // }}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='name'
                      inputLabel={
                        <>
                          {t('O_PROPERTY_CATEGORY')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      register={register('name', formValidation.property)}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='nameAr'
                      inputLabel={
                        <>
                          {t('O_PROPERTY_CATEGORY') + t('O_ARABIC')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register('nameAr', formValidation.propertyAr)}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => handleCategory(false)}
                >
                  Back
                </button>
                <button
                  className='bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                  onClick={handleSubmit(onSubmit)}
                >
                  {addMerchantLoading ? (
                    <div className='spinner-container'>
                      <div className='loading-spinner' />
                    </div>
                  ) : (
                    <>{t('O_ADD')}</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SubCategoryAdd
